// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/1486
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { Environment } from "../enums/environment";
import type { OperatingSystem } from "../enums/operating_system";
import type { DashLinkType } from "../enums/dash_link_type";
import type { TabGroupType } from "../enums/tab_group_type";
import type { DashStackFilterName } from "../enums/dash_stack_filter_name";
import type { DashActivityAction } from "../enums/dash_activity_action";
import type { DashObjectType } from "../enums/dash_object_type";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";
import type { DashSourceType } from "../enums/dash_source_type";
import type { StackCreationType } from "../enums/stack_creation_type";

// Event_name: 'open.dash_link'
// Description: Fires when a user opens a start page / stack link. Links for Start Page & Stacks are available on the suggested focus, calendar, and content
// Owner: stacks
export type Open_DashLink = PAPEventGeneric<
  'stacks',
  'open',
  'dash_link',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // Whether the app dispatching the event is Prod, Test, or Dev (run locally by the developer)
    environment?: Environment;
    // The operating system platform the user is running on.
    operatingSystem?: OperatingSystem;
    // the start time of the event in ms
    startTimeMs?: number;
    // generic property representing build version of whatever is logging this event.
    buildVersion?: string;
    // Dash — Content opened from a non-search result
    dashLinkType?: DashLinkType;
    // stormcrow feature name
    feature?: string;
    // Identifier for Dash predictions
    predictionId?: string;
    // Identifier for item being suggested by Dash ML
    itemId?: string;
    // Rank of the individual suggestion within the group
    predictionPosition?: number;
    // The zero-index returned position of search result in a list of search results.
    resultPosition?: number;
    // The stack id that represents the stack
    stackId?: string;
    // Generated random request id for tracking suggestions in Dash
    dashRequestId?: string;
    // A hashed integer for unique predictions recommended in Dash
    predictionIdHash?: number;
    // A hashed integer for items/content recommended in Dash
    itemIdHash?: number;
    // Meeting IDs that are uuidv4s as generated by neo4j. Used to tie together Dash meetings and related content.
    meetingId?: string;
    // For Dash, the unique, random ID associated with a group of working sets in the Recommendations Panel on Start Page.
    setId?: string;
    // User_id associated with the creator of the content being acted upon
    creatorId?: string;
    // Answers if the event actor on the stack is the same as the creator of the stack
    isOwner?: boolean;
    // marks if the content is shared content
    isShared?: boolean;
    // Index position of the dash dot navigation clicked
    dotPosition?: number;
    // zero-indexed position of an item in a list
    itemPosition?: number;
    // 0 indexed position of the calendar event/item
    calendarItemPosition?: number;
    // Type of Tab groups provided by dash
    tabGroupType?: TabGroupType;
    // An entry point string, used to describe how users are triggering the event as relevant (e.g. browse_file_row_context_menu)
    entryPoint?: string;
    // Hashed URLs accessed by Dash. These are pre-hashed.
    dashUrlHash?: string;
    // The stack id that represents the stack (without extra hashing on the client side)
    unhashedStackId?: string;
    // Hashed URLs accessed by Dash. These are pre-hashed.
    urlHash?: string;
    // Which Dash connector an event is associated with, e.g. Trello.
    dashConnectorId?: string;
    // Whether the user is interacting with their welcome stack
    isWelcomeStack?: boolean;
    // filters for stacks
    dashStackFilterName?: DashStackFilterName;
    // The id of a generic object in dash -- could be a document uuid, a stack id, etc... Differentiated with dash_object_type
    dashObjectId?: string;
    // The dropbox user id of the actor who performed some action (typically not the current user).
    actorUserId?: number;
    // The action type of a dash activity feed item.
    dashActivityAction?: DashActivityAction;
    // The type of an object in dash (ex: stack, document). Used to differentiate different object ids.
    dashObjectType?: DashObjectType;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // This defines where the document source is
    dashSourceType?: DashSourceType;
    // Indicates how the stack was created. See APIv2's StackCreationType.
    stackCreationType?: StackCreationType;
  }
>;

export function PAP_Open_DashLink(properties?: Open_DashLink['properties']): Open_DashLink {
  return <Open_DashLink>{
    class: 'stacks',
    action: 'open',
    object: 'dash_link',
    properties,
  };
}
